import { useMemo } from 'react';

import classNames from 'classnames';

import { useAuth } from '@shared/common/providers/AuthProvider';

import type { RowRenderProps } from '@ui/uikit/components/common/GridTable';
import { GridTable } from '@ui/uikit/components/common/GridTable';

import type { RaffleRoundsItem } from '../../model/web3Raffle/api/useRounds';
import { RaffleCell } from './cells/RaffleCell';
import { RewardCell } from './cells/RewardCell';
import { TicketsCell } from './cells/TicketsCell';
import { TableSkeleton } from './TableSkeleton';
import type { EntriesTableProps } from './types';

const bodyCellClassName = 'flex items-center gap-2';
const cellClassName = 'md-msq:!flex sm:flex sm:justify-start';

export const EntriesTableDesktop = ({
  rounds,
  isEmpty,
  isLoading,
  onClickRow,
}: EntriesTableProps) => {
  const { userEvmWallet } = useAuth();

  const columns = useMemo(() => {
    return [
      {
        label: 'Raffle',
        name: 'raffle',
        cellClassName: classNames(cellClassName, 'w-full'),
        bodyCellClassName,
        render: ({ row }: RowRenderProps<RaffleRoundsItem>) => <RaffleCell row={row} />,
      },
      {
        label: 'My Tickets',
        name: 'tickets',
        cellClassName: classNames(cellClassName, 'w-[224px]'),
        bodyCellClassName,
        render: ({ row }: RowRenderProps<RaffleRoundsItem>) => <TicketsCell row={row} />,
      },
      {
        label: 'My Reward',
        name: 'tickets',
        cellClassName: classNames(cellClassName, 'w-[224px]'),
        bodyCellClassName,
        render: ({ row }: RowRenderProps<RaffleRoundsItem>) => (
          <RewardCell row={row} walletAddress={userEvmWallet?.attributes?.address} />
        ),
      },
    ];
  }, [userEvmWallet?.attributes?.address]);

  return (
    <GridTable
      onClickRow={(row) => onClickRow(row.roundId)}
      columns={columns}
      className="flex flex-col max-sm"
      bodyCellClassName="table-body-cell"
      headRowClassName="table-head-row-a"
      data={rounds}
      //eslint-disable-next-line
      //@ts-ignore
      bodyRowClassName="table-body-row-a"
      rowClassName={classNames(
        `grid-table-row-primary
            grid-cols-[1fr_224px_224px]
            px-0
            max-sm-msq:gap-0
          `,
      )}
    >
      {isEmpty && (
        <p className="my-[96px] m-auto text-center text-base-text-tertiary text-sm">No data yet</p>
      )}
      {isLoading && <TableSkeleton />}
    </GridTable>
  );
};
